export const COMPANY = {
  name: "Elvocom AG",
  street: "Wildenstrasse 3",
  city: "8212 Neuhausen am Rheinfall",
  country: "Schweiz",
  phone: "+41 72 600 8768",
  phoneHref: "tel:+41726008768",
  email: "info@elvocom.ch",
  emailHref: "mailto:info@elvocom.ch",
  website: "www.elvocom.ch",
  lat: 47.6812,
  lng: 8.6155,
};

export const fallbackContact = {
  street: COMPANY.street,
  city: COMPANY.city,
  phone: COMPANY.phone,
  email: COMPANY.email,
  website: COMPANY.website,
  lat: COMPANY.lat,
  lng: COMPANY.lng,
};

export const telHref = (phone) => `tel:${String(phone).replace(/[^+\d]/g, "")}`;
export const mailHref = (email) => `mailto:${email}`;

export const LOGO_URL = "/logo-elvocom.png?v=3";

export const IMAGES = {
  networkHero:
    "https://images.unsplash.com/photo-1691435828932-911a7801adfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByb29tJTIwY2FibGVzfGVufDB8fHx8MTc4MzMzMzAxM3ww&ixlib=rb-4.1.0&q=85",
  fiber:
    "https://images.pexels.com/photos/28286034/pexels-photo-28286034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  electrician:
    "https://images.pexels.com/photos/4792522/pexels-photo-4792522.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  team:
    "https://images.unsplash.com/photo-1758518730083-4c12527b6742?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHRlYW0lMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzgzMzMzMDEzfDA&ixlib=rb-4.1.0&q=85",
  broadband:
    "https://images.unsplash.com/photo-1776026020980-cd69ae72c4f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxzYXRlbGxpdGUlMjBkaXNoJTIwYW50ZW5uYSUyMGluc3RhbGxhdGlvbiUyMHJvb2Z0b3B8ZW58MHx8fHwxNzgzMzMzNTM2fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICE_IMAGES = {
  fiber: IMAGES.fiber,
  network: IMAGES.networkHero,
  broadband: IMAGES.broadband,
  electro: IMAGES.electrician,
};

export const TEAM = [
  { name: "Salvatore Giarratana", roleKey: "roleManaging", photo: "/team/giarratana.png" },
  { name: "Giuseppe Caputo", roleKey: "roleDeputy", photo: "/team/giuseppe-caputo.png" },
  { name: "Genaro Magurno", roleKey: "roleElectrician", photo: "/team/magurno.png" },
  { name: "Giancarlo Margarucci", roleKey: "roleTelecom", photo: "/team/margarucci.png" },
  { name: "Giovanni Caputo", roleKey: "roleTelecom", photo: "/team/giovanni-caputo.png" },
  { name: "Vincenzo Del Giudice", roleKey: "roleTelecom", photo: "/team/delgiudice.png" },
];
